// removed by extract-text-webpack-plugin
module.exports = {"popwrap":"DotValidate-popwrap","header":"DotValidate-header","formWrap":"DotValidate-formWrap","itemWrap":"DotValidate-itemWrap","lefPart":"DotValidate-lefPart","btnWrap":"DotValidate-btnWrap","wide":"DotValidate-wide","error":"DotValidate-error","dropdown":"DotValidate-dropdown","dotWrap":"DotValidate-dotWrap","dotActive":"DotValidate-dotActive","strenchInput":"DotValidate-strenchInput"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DotValidate/index.css
// module id = 1710
// module chunks = 0